import PropTypes from 'prop-types';
import React from 'react';
import ArrowPagination from '../../Elements/ArrowPagination/ArrowPagination';
import CardTitle from '../../Elements/CardTitle/CardTitle';
import MenuTabs from '../../Elements/MenuTabs/MenuTabs';
import CardHeader from '../../Groups/CardHeader/CardHeader';
import SVGIconWrapper from '../../Icons/SVGIconWrapper/SVGIconWrapper';
import Button from '../../Input/Button/Button';

import CommonCardShell from '../../Layout/CommonCardShell/CommonCardShell';
import Icons from '../../Messages/Icons/Icons';

import './NetworkCard.scss';

export default class NetworkCard extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        /**
         * node of children to be rendered
         */
        children: PropTypes.node.isRequired,
        /**
         * function to handleSeeAll click
         */
        handleSeeAll: PropTypes.func.isRequired,
        /**
         * string of title to be rendered on card
         */
        title: PropTypes.string.isRequired,
        /**
         * number of count to be rendered in parentheses
         */
        count: PropTypes.number,
        /**
         * boolean to render tabs or not
         */
        shouldRenderTabs: PropTypes.bool,
        /**
         * array of tab items
         */
        tabItems: PropTypes.array,
        /**
         * boolean to render the count in parentheses
         */
        shouldShowCount: PropTypes.bool,
        /**
         * boolean to show My Network on single page card
         */
        shouldShowTitle: PropTypes.bool,
        /** boolean to show see all btn
         * will be false on single network pages
         */
        shouldShowSeeAll: PropTypes.bool,
    };

    static defaultProps = {
        children: null,
        handleSeeAll: () => {},
        title: 'My Connections',
        shouldRenderTabs: false,
        count: 0,
        shouldShowSeeAll: true,
        arrowPaginationProps: {},
        shouldShowCount: true,
        shouldShowTitle: false,
    };

    handleBack = () => (window.location = '/my-network');

    renderCardHeader() {
        const { count, title, shouldRenderTabs, shouldShowCount } = this.props;

        if (shouldRenderTabs || !shouldShowCount) {
            return title;
        } else {
            const networkCount = `(${count})`;
            return `${title} ${networkCount}`;
        }
    }

    renderBackButton = () => {
        return (
            !this.props.shouldShowSeeAll && (
                <SVGIconWrapper
                    handleClickSVGWrapper={this.handleBack}
                    SVGWrapperCssClass="back-caret"
                >
                    <Icons name="back-caret" />
                </SVGIconWrapper>
            )
        );
    };

    renderHeadingSection = () => {
        return (
            <React.Fragment>
                {this.renderBackButton()}
                {this.props.shouldShowTitle && (
                    <CardTitle title="My Network" headerTag="h1" />
                )}
                <CardHeader>{this.renderCardHeader()}</CardHeader>
            </React.Fragment>
        );
    };

    renderSeeAllButton() {
        const shouldShowSeeAll =
            !!this.props.count && this.props.shouldShowSeeAll;
        return (
            shouldShowSeeAll && (
                <Button
                    value="See all"
                    type="purple-medium-white"
                    onClick={this.props.handleSeeAll}
                    inputStyle="see-all-input"
                    class="see-all-button"
                />
            )
        );
    }

    renderArrowPagination() {
        const { arrowPaginationProps } = this.props;
        const shouldRenderArrowPagination = !!Object.keys(arrowPaginationProps)
            .length;
        return (
            shouldRenderArrowPagination && (
                <ArrowPagination {...arrowPaginationProps} />
            )
        );
    }

    render() {
        return (
            <div className="component-Network-NetworkCard">
                <CommonCardShell>
                    {this.renderHeadingSection()}
                    {this.props.shouldRenderTabs && (
                        <MenuTabs tabItems={this.props.tabItems} />
                    )}

                    <div className="network-items">{this.props.children}</div>

                    {this.renderArrowPagination()}
                    {this.renderSeeAllButton()}
                </CommonCardShell>
            </div>
        );
    }
}
